import {
  Paper,
  Grid2,
  Card,
  Typography,
  CardActionArea,
  Box,
  Button,
  IconButton,
  Divider,
} from "@mui/material";
import React, { useEffect, useState, useCallback } from "react";
import classes from "./css/products-list.module.css";
import * as services from "./../../services/saleng";
import toast, { Toaster } from "react-hot-toast";
import DeleteIcon from "@mui/icons-material/Delete";
import Swal from "sweetalert2";
import { useCart } from "./../../CartContext";
import { useLocation } from "react-router-dom";
import EditIcon from "@mui/icons-material/Edit";
import ImageIcon from "@mui/icons-material/Image";
import CategoryIcon from "@mui/icons-material/Category";
import WeightDialog from "../../components/CarScaleDialog";
import AppBreadcrumbs from "../../components/AppBreadcrumbs";
import CancelIcon from "@mui/icons-material/Cancel";
import PDFDialog from "./components/pdf_dialog";
import LocalShippingIcon from "@mui/icons-material/LocalShipping";
import {
  generateDeliveryNotePdfBlob,
  generateDeliveryNotePdf,
} from "./components/generateDeliveryNotePdf";
import {
  generateDeliveryNoteSalePdfBlob,
  generateDeliveryNoteSalePdf,
} from "./components/generateDeliveryNoteSentPdf";
import {
  generateInvoicePdf,
  generateInvoicePdfBlob,
} from "./components/generateInvoicePdf";
import { formatNumber } from "./../../utils/formatNumber";
import ImageModal from "../../components/ImageModal";
import CarSelectDialog from "./components/CarSelectDialog";
import StockTypeDialog from "./components/StockTypeDialog";
import PackageSelectDialog from "./components/PackageSelectDialog";
import Avatar from "@mui/material/Avatar";
import DocumentScannerIcon from "@mui/icons-material/DocumentScanner";
import Badge from "@mui/material/Badge";
import DescriptionIcon from "@mui/icons-material/Description";
import { green, yellow } from "@mui/material/colors";
import ChecklistIcon from "@mui/icons-material/Checklist";
import ProductFormDialog from "./components/ProductFormDialog";
import SaleCustomerPickerDialog from "./../../components/SaleCustomerPickerDialog";
import SOSelectionDialog from "./components/SOSelectionDialog";
import ItemTableModal from "./../../components/ItemTableModal";
import { getContrastColor } from "./../../utils/fontColor";
import PaymentMethodDialog from "./components/pdf_dialog";

const Page = ({ tabId, tabData }) => {
  const { cart, dispatch } = useCart();
  const [cards, setCards] = useState([]);
  const [data, setData] = useState([]);
  const [categories, setCategories] = useState([]);
  const [filter, setFilter] = useState("ทุกประเภท");
  const [selectedValue, setSelectedValue] = useState(0);
  const [transaction, setTransaction] = useState(null);
  const [totalNetWeight, setTotalNetWeight] = useState();
  const [totalNetPrice, setTotalNetPrice] = useState();
  const [note, setNote] = useState();
  const [isWeighed, setIsWeighed] = useState(true);
  const [selectedMethod, setSelectedMethod] = useState(null);
  const [selectedPackage, setSelectedPackage] = useState(null);

  const [selectedImage, setSelectedImage] = useState([]);
  const [imageList, setImageList] = useState([]);
  const [openImg, setOpenImg] = useState(false);
  const [type, setType] = useState("retail");

  const query = useQuery();
  const transactionId = query.get("id");

  const [soItems, setSoItems] = useState([]);
  const [soSelect, setSoSelect] = useState([]);

  const [transactionBreakdown, setTransactionBreakdown] = useState([]);
  const [selectedItem, setSelectedItem] = React.useState(null);
  const [imageDetail, setImageDetail] = useState([]);

  // dialog
  const [openSOSelectionDialog, setOpenSOSelectionDialog] = useState(false);
  const [openCarDialog, setOpenCarDialog] = useState(false);
  const [openCarSelectDialog, setOpenCarSelectDialog] = useState(false);
  const [openStockTypeDialog, setOpenStockTypeDialog] = useState(false);
  const [openPackageSelectDialog, setOpenPackageSelectDialog] = useState(false);
  const [openCustomerPickerDialog, setOpenCustomerPickerDialog] =
    useState(false);
  const [openProductDialog, setOpenProductDialog] = useState(false);
  const [openPDF, setOpenPDF] = useState(false);
  const [openItemDialog, setOpenItemDialog] = useState(false);
  const [pdfUrl, setPdfUrl] = useState(null);
  const [openPrintDialog, setOpenPrintDialog] = useState(false);

  // useEffect(() => {
  //   let revoke;
  //   const run = async () => {
  //     if (!transaction) return;
  //     const blob = await generateInvoicePdfBlob(transaction);
  //     const url = URL.createObjectURL(blob);
  //     setPdfUrl(url);
  //     revoke = () => URL.revokeObjectURL(url);
  //   };
  //   run();
  //   return () => {
  //     if (revoke) revoke();
  //   };
  // }, [transaction]);

  const setPdfFromBlob = (blob) => {
    if (pdfUrl) URL.revokeObjectURL(pdfUrl);
    const url = URL.createObjectURL(blob);
    setPdfUrl(`${url}#zoom=page-width`); // ให้พอดีกว้าง
  };

  function useQuery() {
    return new URLSearchParams(useLocation().search);
  }

  const handleConfirm = async (data) => {
    // สร้าง images เฉพาะถ้ามี imageUrl
    const imageUrl = data?.imageUrl;
    const images = imageUrl ? [{ imageUrl: imageUrl, type: "img" }] : [];

    let payload = {
      carHeavyWeight: parseFloat(data.heavy || 0),
      carLightWeight: parseFloat(data.light || 0),
      ...(images.length > 0 && { images }), // ส่งเฉพาะถ้ามี
    };

    await services.updateSaleTransaction(payload, transactionId);
    fetchData();
    setOpenCarDialog(false);
  };

  const fetchData = useCallback(async () => {
    try {
      const response = await services.getProductsBranch(true);
      const products = response.data.data;
      const productsWithIndex = products.map((item) => ({
        ...item,
        productId: item.id,
      }));

      const transaction_res = await services.getSaleTransaction(transactionId);
      const trx = transaction_res.data.data;
      const layoutRes = await services.getUserLayout(1);
      const layout = layoutRes?.data ?? [];

      const productMap = {};
      products.forEach((item) => {
        productMap[item.id] = {
          ...item,
          productId: item.id,
          categoryName: item.category?.name ?? "ไม่ระบุ",
          color: item.subCategory?.color ?? "royalblue",
        };
      });

      const sortedCards = layout.length
        ? layout
            .filter((l) => l.box === "box1") // <-- เพิ่ม filter เฉพาะ box1
            .map((l) => productMap[l.productId])
            .filter(Boolean)
        : Object.values(productMap);

      setTransaction(trx);
      setIsWeighed(trx.isWeighed);
      setNote(trx.note || "");

      const totalNetWeight = trx.items.reduce(
        (sum, item) => sum + (item.netWeight || 0),
        0
      );
      const totalNetPrice = trx.items.reduce(
        (sum, item) => sum + (item.netPrice || 0),
        0
      );

      setTotalNetWeight(totalNetWeight);
      setTotalNetPrice(totalNetPrice);

      const categoryMap = products
        .map((p) => p?.category)
        .filter(Boolean)
        .reduce((acc, cur) => {
          if (!acc.some((c) => c.id === cur.id)) {
            acc.push(cur);
          }
          return acc;
        }, []);
      const sortedCategories = categoryMap.sort(
        (a, b) => (a.order ?? 0) - (b.order ?? 0)
      );
      const categories = sortedCategories.map((c) => c.name);
      setCategories?.(categories);
      if (categories.length > 0) {
        setFilter?.(categories[0]);
      }

      if (categories.length > 0) {
        setFilter?.(categories[0]);
      }

      setCards?.(sortedCards);
      setData?.(sortedCards);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  }, [transactionId]);

  // โหลด SO
  useEffect(() => {
    if (!transaction?.customerId || !transaction?.carId) return;
    const fetchPOs = async () => {
      try {
        const res = await services.getSaleOrders({
          customerId: transaction?.customerId,
          carId: transaction?.carId,
          currentDate: new Date().toISOString().split("T")[0],
        });
        setSoItems(res.data.data || []);
      } catch (error) {
        console.error("เกิดข้อผิดพลาดในการดึง PO:", error);
      }
    };

    fetchPOs();
  }, [fetchData, transaction?.carId, transaction?.customerId, transactionId]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  // useEffect สำหรับคำนวณ breakdown และอัปเดต transaction
  useEffect(() => {
    if (!transaction?.items) return;

    const fetchDataAndCalculate = async () => {
      const breakdownList = [];
      const usedPOMap = new Map();

      console.log("soSelect", soSelect);
      transaction.items.forEach((item, index) => {
        const selectSOItems = (soSelect ?? []).flatMap(
          (so) => so.items ?? [so]
        );

        const itemsToUse =
          selectSOItems.length > 0 ? selectSOItems : selectSOItems;

        // Unique PO items
        const soItemsMap = new Map();
        itemsToUse.forEach((p) => soItemsMap.set(p.id, p));

        const preferIds = new Set(item.soItemIds || []);
        const matchingSOItems = Array.from(soItemsMap.values())
          .filter((soItem) => soItem.productId === item.productId)
          .sort((a, b) => {
            const aPrefer = preferIds.has(a.id) ? 1 : 0;
            const bPrefer = preferIds.has(b.id) ? 1 : 0;
            if (aPrefer !== bPrefer) return bPrefer - aPrefer;
            return new Date(a.createdAt || "") - new Date(b.createdAt || "");
          });

        let remainingWeight = Math.max(
          0,
          (item.weight || 0) - (item.deductWeight || 0)
        );
        const breakdown = [];

        // ใช้ PO ถ้ายังเหลือ
        matchingSOItems.forEach((soItem) => {
          if (remainingWeight <= 0) return;

          const usedThisRun = usedPOMap.get(soItem.id) || 0;
          const alreadyUsed = soItem.actualWeight || 0;
          const availableWeight = soItem.unlimitedWeight
            ? Infinity
            : Math.max(0, (soItem.weight || 0) - (alreadyUsed + usedThisRun));
          if (availableWeight <= 0) return;

          const weightToUse = soItem.unlimitedWeight
            ? remainingWeight
            : Math.min(remainingWeight, availableWeight);

          breakdown.push({
            index,
            productId: item.productId,
            productName: item.productName,
            pricePerUnit: 0,
            PricePerUnit: soItem?.salePrice,
            totalPrice: weightToUse * (soItem?.salePrice || 0),
            usedWeight: weightToUse,
            priceSource: "so",
            soInfo: { ...soItem },
            basePrice: item.product?.price,
          });

          usedPOMap.set(soItem.id, usedThisRun + weightToUse);
          remainingWeight -= weightToUse;
        });

        // 3️⃣ ราคากลุ่ม ถ้ายังเหลือ
        if (remainingWeight > 0) {
          breakdown.push({
            index,
            productId: item.productId,
            productName: item.productName,
            pricePerUnit: item.pricePerUnit,
            PricePerUnit: 0,
            totalPrice: (item.pricePerUnit || 0) * remainingWeight,
            usedWeight: remainingWeight,
            priceSource: "group",
            isGroupAdjustment: true,
            basePrice: item.product?.price,
          });
        }

        breakdownList.push(...breakdown);
      });

      // Group breakdown
      const grouped = Object.values(
        breakdownList.reduce((acc, row) => {
          const key = row.index;
          const transactionItem = transaction.items[row.index];
          if (!acc[key]) {
            acc[key] = {
              basePrice: transactionItem.product?.price,
              customerId: transaction.customerId,
              index: row.index,
              productId: row.productId,
              productName: row.productName,
              totalPrice: row.totalPrice,
              usedWeight: row.usedWeight || 0,
              sources: [row.priceSource],
              details: [row],
              originalItem: transactionItem
                ? {
                    ...transactionItem,
                    netWeight:
                      (transactionItem.weight || 0) -
                      (transactionItem.deductWeight || 0) -
                      ((transactionItem.impurities || []).reduce(
                        (s, i) => s + (i.weight || 0),
                        0
                      ) +
                        (transactionItem.deductedItems || []).reduce(
                          (s, d) => s + (d.netWeight || 0),
                          0
                        )),
                  }
                : {
                    id: null,
                    productName: row.productName,
                    productId: row.productId,
                    weight: 0,
                    netWeight: 0,
                    netPrice: row.totalPrice,
                  },
            };
          } else {
            acc[key].totalPrice += row.totalPrice;
            acc[key].usedWeight += row.usedWeight || 0;
            acc[key].sources.push(row.priceSource);
            acc[key].details.push(row);
          }
          return acc;
        }, {})
      );

      setTransactionBreakdown(grouped);

      // สร้าง payload
      const payloads = grouped
        .filter((g) => g.originalItem?.id)
        .map((g) => {
          const soItemsForThisItem = soSelect
            .flatMap((so) => (so.items ? so.items : [so]))
            .filter((p) => p.productId === g.originalItem.productId);

          const singleSO =
            soItemsForThisItem.length === 1 ? soItemsForThisItem[0] : null;

          const groupSource = g.details.find((d) => d.priceSource === "group");
          let pricePerUnit = g.originalItem.pricePerUnit;

          if (!(pricePerUnit > 0) && groupSource?.pricePerUnit != null)
            pricePerUnit = groupSource.pricePerUnit;

          return {
            id: g.originalItem.id,
            productId: g.originalItem.productId,
            productName: g.originalItem.productName,
            pricePerUnit: pricePerUnit || 0,
            weight: g.originalItem.weight || 0,
            deductWeight: g.originalItem.deductWeight || 0,
            netWeight: g.originalItem.netWeight || 0,
            netPrice: g.details.reduce(
              (sum, d) => sum + (d.totalPrice || 0),
              0
            ),
            soItemIds: soItemsForThisItem.map((p) => p.id),
            PricePerUnit: singleSO?.salePrice || null,
            usedWeight: singleSO?.usedWeight || null,
            isGroupAdjustment: soItemsForThisItem.length === 0,
          };
        });

      console.log("payloads", payloads);

      if (payloads.length > 0) {
        try {
          await services.updateSaleTransaction(
            { items: payloads },
            transactionId
          );
        } catch (err) {
          console.error("อัปเดต TransactionItem ไม่สำเร็จ:", err);
        }
      }
    };

    fetchDataAndCalculate();
  }, [transaction, soSelect, transactionId]);

  const handleChange = (event) => {
    const value = event.target.value;
    setFilter(value);

    if (value === "ทุกประเภท") {
      setCards(data);
    } else {
      const filteredProducts = data.filter((product) => {
        return product.category?.name === value;
      });
      setCards(filteredProducts);
    }
  };

  const handleUpdate = async (value) => {
    Swal.fire({
      customClass: {
        container: "my-swal",
      },
      title: `ยืนยันการดำเนินการ`,
      text: "คุณจะไม่สามารถย้อนกลับสิ่งนี้ได้!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "ยืนยัน",
      cancelButtonText: "ยกเลิก",
      reverseButtons: true,
    }).then(async (result) => {
      if (result.isConfirmed) {
        let data = {
          status: value,
        };

        await services.updateSaleTransaction(data, transactionId);
        fetchData();
        if (transaction.status !== "sent") {
          const promises = transaction.items.map((item) => {
            const payload = {
              productId: item.productId,
              quantity: item.netWeight,
              saleTransactionId: transaction.id,
              note: "ขาย",
            };
            return services.updateStockSell(payload);
          });
          await Promise.all(promises);
        }
        toast.success(`บันทึกสำเร็จ`);
      }
    });
  };
  const handleClose = async (value) => {
    setSelectedValue([]);
    setOpenProductDialog(false);
  };

  const handleDeleteItem = async (value) => {
    Swal.fire({
      customClass: {
        container: "my-swal",
      },
      title: `ยืนยันที่จะลบ${value.productName} ?`,
      text: "คุณจะไม่สามารถย้อนกลับสิ่งนี้ได้!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "ยืนยัน",
      cancelButtonText: "ยกเลิก",
      reverseButtons: true,
    }).then(async (result) => {
      if (result.isConfirmed) {
        await services.deleteItemSaleTransaction(transactionId, value.id);
        toast.success(`ลบรายการ ${value.productName} สำเร็จ`);
        fetchData();
      }
    });
  };

  const handleClick = (index) => {
    setSelectedPackage(null);
    setSelectedValue(index);
    setOpenStockTypeDialog(true);
  };

  const handleClickEdit = (value) => {
    setOpenProductDialog(true);
    const item = {
      itemId: value.id,
      title: value.productName,
      finalPrice: value.pricePerUnit,
      id: value.productId,
      weight: parseFloat(value.weight || 0),
      deduct: parseFloat(value.deductWeight || 0),
      netWeight: parseFloat(value.netWeight || 0),
      impurities: value.impurities,
      totalImpurityWeight: value.impurityWeight,
    };
    setSelectedValue(item);
  };

  const handleSelectPDF = async (select) => {
    if (select === "1") {
      generateDeliveryNotePdf(transaction);
    } else if (select === "2") {
      generateDeliveryNoteSalePdf(transaction);
    } else {
      generateInvoicePdf(transaction);
    }
  };

  const handleSubmit = async (value) => {
    const {
      title,
      id,
      weight,
      finalPrice,
      deduct,
      netWeight,
      imageUrl,
      itemId, // ใช้ตอน update เท่านั้น
    } = value;

    setOpenProductDialog(false);

    // เฉพาะถ้ามี imageUrl
    const images = imageUrl ? [{ imageUrl, type: "img" }] : [];

    const mainItem = {
      ...(itemId && { id: itemId }), // ใส่ id เฉพาะตอน update
      productName: title,
      pricePerUnit: finalPrice,
      weight: parseFloat(weight || 0),
      netWeight: parseFloat(netWeight || 0),
      netPrice: parseFloat((netWeight || 0) * (finalPrice || 0)),
      productId: id,
      deductWeight: deduct,
      ...(images.length > 0 && { images }),
    };

    const res = await services.updateSaleTransaction(
      { items: [mainItem] },
      transactionId
    );

    console.log("res: ", res);

    // if (mode === "create" && selectedPackage) {
    //   const res2 = await services.deletePackage(selectedPackage.id);
    //   console.log("res2", res2);
    // }

    // toast.success(
    //   `${mode === "create" ? "เพิ่ม" : "บันทึก"}รายการ ${title} สำเร็จ`
    // );

    setSelectedValue([]);
    fetchData();
  };

  const handleChangeCustomer = async (customer) => {
    console.log("customer", customer);
    setOpenCustomerPickerDialog(false);

    const currentCustomerId = transaction.customerId;
    const newCustomerId = customer?.customer?.id;

    const payload = {
      customerId: newCustomerId,
      customerName: customer?.customer?.name ?? null,
      carId: customer?.car?.id ?? null,
      driverId: customer?.driver?.id ?? null,
    };

    console.log("payload", payload);
    await services.updateSaleTransaction(payload, transactionId);

    if (currentCustomerId === newCustomerId) {
      await fetchData();
      return;
    }

    try {
      // เตรียมอัพเดตราคาใหม่ + ล้าง PO ของทุก item แบบ batch ในครั้งเดียว
      // ดึงราคากลุ่ม (basePrice + groupAdjustment) แบบ parallel
      const items = transaction?.items || [];

      const pricedItems = await Promise.all(
        items.map(async (item) => {
          try {
            const res = await services.getPriceProduct({
              customerId: newCustomerId,
              productId: item.productId,
            });
            const data = res?.data?.data || {};
            const newPrice =
              (data.basePrice ?? 0) + (data.groupAdjustment ?? 0);

            return {
              id: item.id,
              // ราคาใหม่ตามกลุ่มของซัพพลายเออร์ใหม่
              pricePerUnit: newPrice,
              // ล้าง PO ที่เคยผูกไว้กับ item นี้
              poId: null,
              usedWeight: null,
              poPricePerUnit: null,
            };
          } catch (e) {
            console.error("getPriceProduct failed for item", item.id, e);
            // ถ้าดึงราคาไม่สำเร็จ ก็ยังล้าง PO ออก แต่คงราคาเดิมไว้
            return {
              id: item.id,
              pricePerUnit: item.pricePerUnit ?? 0,
              poId: null,
              usedWeight: null,
              poPricePerUnit: null,
            };
          }
        })
      );

      // updateTransaction ครั้งเดียวด้วย items ทั้งชุด
      await services.updateSaleTransaction(
        { items: pricedItems },
        transactionId
      );

      // เคลียร์ state PO ที่เลือกไว้ (กันงง)
      // setPoSelect([]);

      toast.success("เปลี่ยนซัพพลายเออร์เรียบร้อย");
      await fetchData();
    } catch (err) {
      console.error("Error handleChangeCustomer:", err);
      toast.error("อัปเดตราคา/ล้าง PO ไม่สำเร็จ");
    }
  };

  return (
    <>
      <Toaster position="bottom-right" reverseOrder={false} />
      <Box p={2}>
        <AppBreadcrumbs />

        <Box mt={2}>
          <Grid2 container spacing={0.5}>
            <Grid2 size={5}>
              <Paper
                className={classes["products-container"]}
                elevation={5}
                square
                style={{
                  display: "flex",
                  flexDirection: "column",
                  height: "80vh",
                }}
              >
                {/* ส่วนหัว */}
                {transaction && (
                  <>
                    <Box sx={{ mb: 2, padding: 0 }}>
                      <Box
                        sx={{
                          border: "1px solid #ccc",
                          backgroundColor: "#e0f7fa",
                          borderRadius: "4px",
                        }}
                      >
                        {/* ชื่อซัพพลายเออร์ */}
                        <Box display="flex" alignItems="center">
                          <Box
                            flex={1}
                            sx={{
                              cursor: "pointer",
                              "&:hover": {
                                bgcolor: "grey.100",
                              },
                            }}
                            onClick={() => setOpenCustomerPickerDialog(true)}
                          >
                            <Box
                              display="flex"
                              justifyContent="space-between"
                              alignItems="center"
                              p={1.5}
                            >
                              {/* ชื่อ + รถ */}
                              <Box display="flex" gap={1} alignItems="center">
                                {/* กลุ่ม */}
                                {transaction.customer?.customerGroup
                                  ?.name?.[0] && (
                                  <Avatar>
                                    {
                                      transaction.customer?.customerGroup
                                        ?.name?.[0]
                                    }
                                  </Avatar>
                                )}
                                {/* ชื่อ */}
                                <Typography>
                                  <strong>
                                    ชื่อ : {transaction?.customerName}
                                  </strong>
                                </Typography>
                                {/* รถ */}
                                <Typography>
                                  {transaction?.car?.type
                                    ? `${transaction.car.type} - `
                                    : ""}
                                  {transaction?.car?.license
                                    ? `${transaction.car.license}`
                                    : ""}{" "}
                                  {transaction?.car?.province
                                    ? `(${transaction.car.province})`
                                    : ""}
                                </Typography>
                                {/* <Typography>
                              {transaction?.driver?.name
                                ? `${transaction.driver.name}`
                                : ""}{" "}
                              {transaction?.driver?.surname
                                ? `${transaction.driver.surname}`
                                : ""}
                            </Typography> */}
                              </Box>
                              <Box>
                                <EditIcon />
                              </Box>
                            </Box>
                          </Box>

                          {/* icons */}
                          <Box>
                            <IconButton
                              onClick={() => setOpenSOSelectionDialog(true)}
                            >
                              <DocumentScannerIcon />
                            </IconButton>
                          </Box>
                        </Box>
                      </Box>
                    </Box>
                  </>
                )}

                {/* กล่องแสดง mockItems */}
                <Box
                  sx={{
                    flex: 1,
                    overflowY: "auto",
                    minHeight: 0,
                  }}
                >
                  {transactionBreakdown?.length ? (
                    transactionBreakdown
                      .filter(
                        (item) =>
                          item.originalItem && item.originalItem.id != null
                      )
                      .map((item, index) => {
                        return (
                          <Paper key={index} variant="outlined" sx={{ mb: 1 }}>
                            <Box>
                              <Box
                                display="flex"
                                justifyContent="space-between"
                              >
                                {/* รายการสินค้า */}
                                <Box
                                  flex={1}
                                  p={2}
                                  sx={{
                                    cursor: "pointer",
                                    "&:hover": {
                                      bgcolor: "grey.100",
                                    },
                                  }}
                                  onClick={() =>
                                    handleClickEdit(item?.originalItem)
                                  }
                                >
                                  {/* ชื่อสินค้า + ราคาสินค้า */}
                                  <Box
                                    display="flex"
                                    justifyContent="space-between"
                                  >
                                    {/* ชื่อสินค้า */}
                                    <Box
                                      display="flex"
                                      alignItems="center"
                                      gap={1}
                                    >
                                      <Typography
                                        variant="subtitle1"
                                        sx={{
                                          fontSize: 20,
                                          fontWeight: "bold",
                                          flexShrink: 1,
                                        }}
                                      >
                                        {index + 1}. {item?.productName}
                                      </Typography>

                                      <EditIcon fontSize="small" />
                                    </Box>
                                    {/* ราคาสินค้า */}
                                    <Box display="flex" gap={1}>
                                      {item?.details?.length > 1 &&
                                        (() => {
                                          const basePrice =
                                            item?.originalItem?.product?.price;
                                          const totalPrice = item.totalPrice;
                                          const usedWeight = item.usedWeight;
                                          const average =
                                            totalPrice / usedWeight;
                                          const diff = average - basePrice;
                                          return (
                                            <Box
                                              /* key={index}  // ใช้ key ต่อเมื่ออยู่ใน .map เท่านั้น */
                                              display="flex"
                                              justifyContent="flex-end"
                                              alignItems="center"
                                            >
                                              <Box
                                                display="flex"
                                                sx={{
                                                  position: "relative",
                                                  bgcolor: green[100],
                                                  borderRadius: 1,
                                                  gap: 1,
                                                  px: 1,
                                                  alignItems: "center",
                                                }}
                                              >
                                                {/* ไอคอน */}
                                                <DocumentScannerIcon fontSize="small" />

                                                {/* ข้อความ */}
                                                <Typography>
                                                  {formatNumber(average)}{" "}
                                                  บาท/กก.
                                                </Typography>
                                              </Box>
                                            </Box>
                                          );
                                        })()}

                                      {item?.details?.length === 1 &&
                                        item.details.map((detail, index) => {
                                          return (
                                            <Box
                                              key={index}
                                              display="flex"
                                              justifyContent="flex-end"
                                              alignItems="center"
                                            >
                                              <Box
                                                display="flex"
                                                sx={{
                                                  position: "relative",
                                                  bgcolor: green[100],
                                                  borderRadius: 1,
                                                  gap: 1,
                                                  px: 1,
                                                  alignItems: "center",
                                                }}
                                              >
                                                {/* ไอคอน */}
                                                <CategoryIcon fontSize="small" />

                                                {/* ข้อความ */}
                                                <Typography>
                                                  {detail.priceSource === "so"
                                                    ? formatNumber(
                                                        detail.PricePerUnit
                                                      )
                                                    : formatNumber(
                                                        detail.pricePerUnit
                                                      )}{" "}
                                                  บาท/กก.
                                                </Typography>
                                              </Box>
                                            </Box>
                                          );
                                        })}
                                    </Box>
                                  </Box>

                                  {/* รายละเอียดน้ำหนัก */}
                                  <Box display="flex" mt={1} gap={2}>
                                    <Typography>
                                      รวมน้ำหนัก:{" "}
                                      {formatNumber(item?.originalItem?.weight)}
                                    </Typography>
                                    <Typography>
                                      {" "}
                                      หัก:{" "}
                                      {formatNumber(
                                        item?.originalItem?.deductWeight
                                      )}
                                    </Typography>
                                    <Typography>
                                      {" "}
                                      สิ่งเจือปน:{" "}
                                      {formatNumber(
                                        item?.originalItem?.impurityWeight
                                      )}
                                    </Typography>
                                    <Typography>
                                      {" "}
                                      ={" "}
                                      {formatNumber(
                                        item?.originalItem?.netWeight
                                      )}
                                    </Typography>
                                  </Box>

                                  <Box display="flex" justifyContent="flex-end">
                                    <Typography>
                                      <strong>
                                        {formatNumber(item.totalPrice)}
                                      </strong>{" "}
                                      บาท
                                    </Typography>
                                  </Box>

                                  <Box>
                                    <Box>
                                      {[
                                        ...(
                                          item?.originalItem?.impurities || []
                                        ).map((i) => i.type),
                                        ...(item?.originalItem?.deductedItems
                                          ?.length
                                          ? item?.originalItem?.deductedItems.map(
                                              (d) =>
                                                `หักเป็น${d.productName || ""}`
                                            )
                                          : []),
                                      ].filter(Boolean).length > 0 && (
                                        <Typography>
                                          <strong>สิ่งเจือปน</strong>{" "}
                                          {[
                                            ...(
                                              item?.originalItem?.impurities ||
                                              []
                                            ).map((i) => i.type),
                                            ...(item?.originalItem
                                              ?.deductedItems?.length
                                              ? item?.originalItem?.deductedItems.map(
                                                  (d) =>
                                                    `หักเป็น${d.productName || ""}`
                                                )
                                              : []),
                                          ]
                                            .filter(Boolean)
                                            .join(", ")}
                                        </Typography>
                                      )}
                                    </Box>
                                    <Box mt={1}>
                                      {item?.originalItem?.sourceItem && (
                                        <Typography>
                                          <DescriptionIcon /> หักเป็นสินค้าอื่น
                                          จาก{" "}
                                          {
                                            item?.originalItem?.sourceItem
                                              ?.productName
                                          }
                                        </Typography>
                                      )}
                                    </Box>
                                    <Box mt={1} display={"flex"} gap={1}>
                                      <Box>
                                        {item.details.some(
                                          (d) => d.priceSource === "so"
                                        ) && (
                                          <Typography>
                                            <strong>สินค้านี้ใช้ราคา</strong> SO
                                            {item.details
                                              .filter(
                                                (d) => d.priceSource === "so"
                                              )
                                              .map(
                                                (d) =>
                                                  ` #${d.soInfo?.saleOrderId}`
                                              )
                                              .filter(Boolean)
                                              .join(", ")}
                                          </Typography>
                                        )}
                                      </Box>

                                      <Box>
                                        {item.details.some(
                                          (d) => d.priceSource === "so"
                                        ) &&
                                          item.details.some(
                                            (d) => d.priceSource === "group"
                                          ) && (
                                            <Typography
                                              variant="body2"
                                              color={yellow[700]}
                                            >
                                              <strong>
                                                (ส่วนเกิน{" "}
                                                {item.details
                                                  .filter(
                                                    (d) =>
                                                      d.priceSource === "group"
                                                  )
                                                  .reduce(
                                                    (sum, d) =>
                                                      formatNumber(
                                                        sum + d.usedWeight
                                                      ),
                                                    0
                                                  )}{" "}
                                                ราคากลุ่ม)
                                              </strong>
                                            </Typography>
                                          )}
                                      </Box>
                                    </Box>
                                  </Box>
                                </Box>

                                {/* icons */}
                                <Box
                                  display="flex"
                                  flexDirection="column"
                                  justifyContent="space-around"
                                  pr={1}
                                >
                                  {/* ลบ */}
                                  <IconButton
                                    color="error"
                                    onClick={() =>
                                      handleDeleteItem(item.originalItem)
                                    }
                                  >
                                    <DeleteIcon />
                                  </IconButton>

                                  {/* รูป */}
                                  <Badge
                                    badgeContent={
                                      item?.originalItem?.images.length || 0
                                    }
                                    color="error"
                                    overlap="circular"
                                    anchorOrigin={{
                                      vertical: "top",
                                      horizontal: "right",
                                    }}
                                    sx={{
                                      "& .MuiBadge-badge": {
                                        right: 4,
                                        top: 4,
                                        fontWeight: 700,
                                      },
                                    }}
                                  >
                                    <IconButton
                                      onClick={() => {
                                        setSelectedImage([
                                          item?.originalItem?.images[
                                            item?.originalItem?.images.length -
                                              1
                                          ],
                                        ]);
                                        setImageList(
                                          item?.originalItem?.images
                                        );
                                        setImageDetail(item?.originalItem);
                                        setOpenImg(true);
                                        setType("item");
                                      }}
                                      disabled={
                                        !item?.originalItem?.images[
                                          item?.originalItem?.images.length - 1
                                        ]
                                      }
                                    >
                                      <ImageIcon />
                                    </IconButton>
                                  </Badge>

                                  {/* รายการ */}
                                  {item?.sources.includes("so") && (
                                    <Badge
                                      badgeContent={item?.details?.length || 0}
                                      color="error"
                                      overlap="circular"
                                      anchorOrigin={{
                                        vertical: "top",
                                        horizontal: "right",
                                      }}
                                      sx={{
                                        "& .MuiBadge-badge": {
                                          right: 4,
                                          top: 4,
                                          fontWeight: 700,
                                        },
                                      }}
                                    >
                                      <IconButton
                                        onClick={() => {
                                          setSelectedItem(item);
                                          setOpenItemDialog(true);
                                        }}
                                        aria-label="เปิดรายละเอียดรายการ"
                                      >
                                        <ChecklistIcon />
                                      </IconButton>
                                    </Badge>
                                  )}
                                </Box>
                              </Box>
                            </Box>
                          </Paper>
                        );
                      })
                  ) : (
                    <Typography
                      variant="subtitle1"
                      sx={{
                        width: "100%",
                        textAlign: "center",
                        color: "text.secondary",
                      }}
                    >
                      ไม่มีรายการ
                    </Typography>
                  )}
                </Box>

                {/* Footer */}
                <Box
                  sx={{
                    borderTop: "1px solid #ccc",
                  }}
                  pt={2}
                >
                  <Paper variant="outlined">
                    {/* น้ำหนักรถขนส่ง */}
                    <Box display="flex">
                      {/* ช่องน้ำหนักรถ */}
                      <Box
                        flex={1}
                        pr={10}
                        p={2}
                        onClick={() => setOpenCarDialog(true)}
                        sx={{
                          cursor: "pointer",
                          "&:hover": {
                            bgcolor: "grey.100",
                          },
                        }}
                      >
                        <Box display="flex" alignItems="center" gap={1} mb={1}>
                          <Typography variant="h6">น้ำหนักรถขนส่ง</Typography>
                          <EditIcon fontSize="small" />
                        </Box>
                        <Box display="flex" gap={4}>
                          {/* รถหนัก */}
                          <Box display="flex" gap={1}>
                            <Typography>รถหนัก: </Typography>
                            <Typography>
                              {formatNumber(transaction?.carHeavyWeight)}
                            </Typography>
                          </Box>
                          {/* รถเบา */}
                          <Box display="flex" gap={1}>
                            <Typography>รถเบา:</Typography>
                            <Typography>
                              {formatNumber(transaction?.carLightWeight)}
                            </Typography>
                          </Box>
                          {/* รวม */}
                          <Box display="flex" gap={1}>
                            <Typography>
                              ={" "}
                              {formatNumber(
                                transaction?.carHeavyWeight -
                                  transaction?.carLightWeight
                              )}{" "}
                              กก.
                            </Typography>
                          </Box>
                        </Box>
                      </Box>

                      {/* ช่องรูปภาพ รถ */}
                      <Box pr={1}>
                        <Box
                          display="flex"
                          flexDirection="column"
                          justifyContent="space-around"
                          gap={1}
                        >
                          <Badge
                            badgeContent={transaction?.images.length || 0}
                            color="error"
                            overlap="circular"
                            anchorOrigin={{
                              vertical: "top",
                              horizontal: "right",
                            }}
                            sx={{
                              "& .MuiBadge-badge": {
                                right: 4,
                                top: 4,
                                fontWeight: 700,
                              },
                            }}
                          >
                            <IconButton
                              onClick={() => {
                                setSelectedImage([
                                  transaction?.images[
                                    transaction?.images.length - 1
                                  ],
                                ]);
                                setImageDetail({
                                  carHeavyWeight: transaction?.carHeavyWeight,
                                  carLightWeight: transaction?.carLightWeight,
                                  images: transaction?.images,
                                });
                                setImageList(transaction?.images);
                                setType("car");
                                setOpenImg(true);
                              }}
                              disabled={
                                !transaction?.images[
                                  transaction?.images.length - 1
                                ]
                              }
                            >
                              <ImageIcon />
                            </IconButton>
                          </Badge>
                          <IconButton
                          // onClick={() => setOpenTransactionDialog(true)}
                          >
                            <ChecklistIcon />
                          </IconButton>
                        </Box>
                      </Box>
                    </Box>

                    <Divider />

                    {/* น้ำหนักสุทธิ */}
                    <Box p={1}>
                      <Box p={1}>
                        {/* น้ำหนักรวม */}
                        <Box display="flex" justifyContent="space-between">
                          <Typography>
                            น้ำหนักสุทธิ{" "}
                            <strong>{formatNumber(totalNetWeight)}</strong> กก.
                          </Typography>
                          <Typography>
                            น้ำหนักรถ{" "}
                            <strong>
                              {" "}
                              {formatNumber(
                                transaction?.carHeavyWeight -
                                  transaction?.carLightWeight
                              )}
                            </strong>{" "}
                            กก.
                          </Typography>
                        </Box>
                      </Box>
                    </Box>
                  </Paper>
                  <Box className={classes["title-container"]} sx={{ mt: 2 }}>
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        flex: 1,
                        gap: "0.5rem",
                      }}
                    >
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                        }}
                      >
                        <p>ยอดก่อนรวมภาษี:</p>
                        <p>
                          {formatNumber(totalNetPrice ?? 0)}
                          {"บาท"}
                        </p>
                      </div>
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                        }}
                      >
                        <p>ภาษีมูลค่าเพิ่ม 7%:</p>
                        <p>0.00 {" บาท"}</p>
                      </div>
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                        }}
                      >
                        <Typography variant="h6" color="primary">
                          ยอดสุทธิ:
                        </Typography>{" "}
                        <b>
                          <Typography variant="h6" color="primary">
                            <strong> {formatNumber(totalNetPrice ?? 0)}</strong>
                          </Typography>
                        </b>
                      </div>
                    </div>
                  </Box>
                </Box>
              </Paper>
            </Grid2>
            <Grid2 size={1.6}>
              <Paper
                className={classes["products-container"]}
                elevation={5}
                square
                style={{
                  display: "flex",
                  flexDirection: "column",
                  height: "80vh",
                }}
              >
                <Box
                  sx={{
                    // width: 180,
                    flexShrink: 0,
                    backgroundColor: "#fff",
                    overflowY: "auto",
                    paddingRight: 1,
                    boxSizing: "border-box",
                  }}
                >
                  {transaction?.status === "confirm" && (
                    <>
                      <Typography
                        variant="h6"
                        sx={{ mb: 2, textAlign: "center" }}
                      >
                        เอกสารประกอบการขาย
                      </Typography>

                      <Box
                        sx={{
                          display: "flex",
                          flexDirection: "column",
                          gap: 1,
                        }}
                      >
                        <Button
                          variant="contained"
                          color="success"
                          sx={{ height: 64, fontSize: 18 }}
                          onClick={async () => {
                            const blob =
                              await generateDeliveryNotePdfBlob(transaction);
                            setPdfFromBlob(blob);
                          }}
                        >
                          รายการสินค้า
                        </Button>

                        <Button
                          variant="contained"
                          color="info"
                          sx={{ height: 64, fontSize: 18 }}
                          onClick={async () => {
                            const blob =
                              await generateDeliveryNoteSalePdfBlob(
                                transaction
                              );
                            setPdfFromBlob(blob);
                          }}
                        >
                          ใบขนส่งสินค้า
                        </Button>

                        <Button
                          variant="contained"
                          color="warning"
                          sx={{ height: 64, fontSize: 18 }}
                          onClick={async () => {
                            const blob =
                              await generateInvoicePdfBlob(transaction);
                            setPdfFromBlob(blob);
                          }}
                        >
                          ใบแจ้งหนี้
                        </Button>
                      </Box>
                    </>
                  )}

                  {transaction?.status !== "confirm" && (
                    <>
                      <Typography
                        variant="h6"
                        sx={{ mb: 2, textAlign: "center" }}
                      >
                        หมวดหมู่
                      </Typography>

                      {categories.map((name, index) => (
                        <Button
                          key={index}
                          variant={filter === name ? "contained" : "outlined"}
                          fullWidth
                          sx={{ mb: 1, height: 64, fontSize: 18 }}
                          onClick={() =>
                            handleChange({ target: { value: name } })
                          }
                        >
                          {name}
                        </Button>
                      ))}
                    </>
                  )}
                </Box>
              </Paper>
            </Grid2>

            <Grid2 size={5.4}>
              <Paper
                className={classes["products-container"]}
                elevation={5}
                square
                style={{
                  display: "flex",
                  flexDirection: "column",
                  height: "80vh",
                }}
              >
                {transaction?.status === "confirm" && (
                  <>
                    {pdfUrl ? (
                      <Box
                        sx={{
                          flex: 1,
                          minHeight: 0,
                          border: "1px solid #ddd",
                          borderRadius: 2,
                          overflow: "hidden",
                          bgcolor: "#fff",
                        }}
                      >
                        <iframe
                          src={pdfUrl}
                          title="เอกสาร"
                          style={{
                            width: "100%",
                            height: "100%",
                            border: "none",
                            display: "block",
                          }}
                        />
                      </Box>
                    ) : (
                      <Box
                        sx={{
                          flex: 1,
                          minHeight: 0,
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          color: "text.secondary",
                        }}
                      >
                        เลือกเอกสารทางซ้ายเพื่อแสดง
                      </Box>
                    )}
                  </>
                )}

                {transaction?.status !== "confirm" && (
                  <>
                    <Box
                      sx={{
                        flexGrow: 1,
                        p: 1,
                        overflowY: "auto",
                      }}
                    >
                      <Box
                        sx={{
                          display: "grid",
                          gridTemplateColumns: "repeat(4, 1fr)",
                          gap: 1,
                        }}
                      >
                        {cards
                          .filter((card) =>
                            filter === "ทุกประเภท"
                              ? true
                              : card.category.name === filter
                          )
                          .map((card, index) => (
                            <Card
                              key={index}
                              sx={{
                                height: 100,
                                display: "flex",
                                flexDirection: "column",
                                justifyContent: "center",
                                p: 0,
                                m: 0,
                                overflow: "hidden",
                              }}
                            >
                              <CardActionArea
                                onClick={() => handleClick(card)}
                                disabled={card?.status === "payed"}
                                sx={{
                                  width: "100%",
                                  height: "100%",
                                  backgroundColor:
                                    card?.subCategory.color ?? "transparent",
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "center",
                                  p: 0.5,
                                  opacity: card?.status === "payed" ? 0.5 : 1,
                                }}
                              >
                                <Typography
                                  variant="h6"
                                  fontWeight="bold"
                                  sx={{
                                    overflow: "hidden",
                                    textOverflow: "ellipsis",
                                    textAlign: "center",
                                    width: "100%",
                                    color: getContrastColor(
                                      card?.subCategory.color ?? "#ffffff"
                                    ),
                                  }}
                                >
                                  {card.title}
                                </Typography>
                              </CardActionArea>
                            </Card>
                          ))}
                      </Box>
                    </Box>
                  </>
                )}

                <Box
                  sx={{
                    padding: "1rem",
                    borderTop: "1px solid #ccc",
                    backgroundColor: "#fff",
                  }}
                >
                  {transaction?.status === "waiting" && (
                    <Box
                      sx={{ display: "flex", justifyContent: "space-between" }}
                    >
                      <Box sx={{ width: "100%" }}>
                        <Box
                          sx={{
                            display: "flex",
                            justifyContent: "flex-end",
                            marginBottom: "8px",
                            gap: 1,
                          }}
                        >
                          <Button
                            sx={{
                              height: "5rem",
                              fontSize: 20,
                              bgcolor: "#000000",
                              flex: 1,
                              "&:hover": {},
                            }}
                            variant="contained"
                            onClick={() => handleUpdate("sent")}
                          >
                            ส่งและยืนยันน้ำหนัก
                          </Button>
                          <Button
                            sx={{
                              height: "5rem",
                              fontSize: 20,
                              bgcolor: "#008000",
                              flex: 1,
                              "&:hover": {},
                            }}
                            variant="contained"
                            onClick={() => handleUpdate("payed")}
                          >
                            ส่งและรับเงิน
                          </Button>
                        </Box>
                        <Box
                          sx={{
                            display: "flex",
                            justifyContent: "flex-end",
                            gap: 1,
                          }}
                        >
                          <Button
                            sx={{
                              height: "5rem",
                              fontSize: 20,
                              bgcolor: "#FFFFFF",
                              flex: 1,
                              "&:hover": {},
                            }}
                            variant="contained"
                            color="black"
                            onClick={() => (window.location.href = "/sale")}
                          >
                            ปิดBatch
                          </Button>
                          <Button
                            sx={{
                              height: "5rem",
                              fontSize: 20,
                              bgcolor: "#FF0000",
                              flex: 1,
                              "&:hover": {},
                            }}
                            variant="contained"
                            color="error"
                            onClick={() => handleUpdate("cancel")}
                          >
                            ยกเลิกBatch
                          </Button>
                        </Box>
                      </Box>
                    </Box>
                  )}

                  {transaction?.status === "sent" && (
                    <Box
                      sx={{ display: "flex", justifyContent: "space-between" }}
                    >
                      <Box sx={{ width: "100%" }}>
                        <Box
                          sx={{
                            display: "flex",
                            justifyContent: "flex-end",
                            marginBottom: "8px",
                            gap: 1,
                          }}
                        >
                          <Button
                            sx={{
                              height: "5rem",
                              fontSize: 20,
                              bgcolor: "#C5C5C5",
                              flex: 1,
                              "&:hover": {},
                            }}
                            color="black"
                            variant="contained"
                            onClick={() => setOpenPrintDialog(true)}
                          >
                            ปริ้นเอกสาร
                          </Button>
                          <Button
                            sx={{
                              height: "5rem",
                              fontSize: 20,
                              bgcolor: "#FFBF00",
                              flex: 1,
                              "&:hover": {},
                            }}
                            color="black"
                            variant="contained"
                            onClick={() => handleUpdate("confirm")}
                          >
                            ยืนยันการขายสินค้า
                          </Button>
                        </Box>
                        <Box
                          sx={{
                            display: "flex",
                            justifyContent: "flex-end",
                            gap: 1,
                          }}
                        >
                          <Button
                            sx={{
                              height: "5rem",
                              fontSize: 20,
                              bgcolor: "#FFFFFF",
                              flex: 1,
                              "&:hover": {},
                            }}
                            variant="contained"
                            color="black"
                            onClick={() => (window.location.href = "/sale")}
                          >
                            ปิดBatch
                          </Button>
                          <Button
                            sx={{
                              height: "5rem",
                              fontSize: 20,
                              bgcolor: "#FF0000",
                              flex: 1,
                              "&:hover": {},
                            }}
                            variant="contained"
                            color="error"
                            onClick={() => handleUpdate("waiting")}
                          >
                            ยกเลิกการส่ง
                          </Button>
                        </Box>
                      </Box>
                    </Box>
                  )}

                  {transaction?.status === "confirm" && (
                    <Box
                      sx={{ display: "flex", justifyContent: "space-between" }}
                    >
                      <Box sx={{ width: "100%" }}>
                        <Box
                          sx={{
                            display: "flex",
                            justifyContent: "flex-end",
                            marginBottom: "8px",
                            gap: 1,
                          }}
                        >
                          <Button
                            sx={{
                              height: "5rem",
                              fontSize: 20,
                              bgcolor: "#008000",
                              flex: 1,
                              "&:hover": {},
                            }}
                            variant="contained"
                            onClick={() => handleUpdate("payed")}
                          >
                            ได้รับเงินแล้ว
                          </Button>
                        </Box>
                        <Box
                          sx={{
                            display: "flex",
                            justifyContent: "flex-end",
                            gap: 1,
                          }}
                        >
                          <Button
                            sx={{
                              height: "5rem",
                              fontSize: 20,
                              bgcolor: "#FFFFFF",
                              flex: 1,
                              "&:hover": {},
                            }}
                            variant="contained"
                            color="black"
                            onClick={() => (window.location.href = "/sale")}
                          >
                            ปิดBatch
                          </Button>
                          <Button
                            sx={{
                              height: "5rem",
                              fontSize: 20,
                              bgcolor: "#FF0000",
                              flex: 1,
                              "&:hover": {},
                            }}
                            variant="contained"
                            color="error"
                            onClick={() => handleUpdate("waiting")}
                          >
                            ยกเลิกการยืนยัน
                          </Button>
                        </Box>
                      </Box>
                    </Box>
                  )}
                </Box>
              </Paper>
            </Grid2>
          </Grid2>
        </Box>
      </Box>

      <ImageModal
        open={openImg}
        onClose={() => setOpenImg(false)}
        imageDetail={imageDetail}
        selectedImage={selectedImage}
        type={type}
      />

      <ProductFormDialog
        selectedValue={selectedValue}
        transaction={transaction}
        customer={transaction?.customer}
        open={openProductDialog}
        onClose={handleClose}
        onSubmit={handleSubmit}
      />

      <WeightDialog
        transaction={transaction}
        open={openCarDialog}
        onClose={() => setOpenCarDialog(false)}
        onConfirm={handleConfirm}
      />

      <PDFDialog
        open={openPDF}
        onClose={() => setOpenPDF(false)}
        onSelect={handleSelectPDF}
      />

      <SaleCustomerPickerDialog
        open={openCustomerPickerDialog}
        onClose={() => setOpenCustomerPickerDialog(false)}
        showCreateButton
        onSuccess={handleChangeCustomer}
      />

      <SOSelectionDialog
        open={openSOSelectionDialog}
        onClose={() => setOpenSOSelectionDialog(false)}
        transaction={transaction}
        soItems={soItems}
        soSelect={soSelect}
        setSoSelect={setSoSelect}
      />

      <StockTypeDialog
        open={openStockTypeDialog}
        onClose={() => setOpenStockTypeDialog(false)}
        selected={type}
        badgeNumber={7} // เอาออกได้ถ้าไม่ต้องการ
        onSelect={(val) => {
          if (val === "retail") {
            setOpenProductDialog(true);
            setOpenStockTypeDialog(false);
          } else {
            setOpenPackageSelectDialog(true);
          }
        }}
      />

      <PackageSelectDialog
        open={openPackageSelectDialog}
        onClose={() => setOpenPackageSelectDialog(false)}
        productId={selectedValue?.id}
        onConfirm={(row) => {
          console.log("เลือกแพ็ค:", row);
          setSelectedPackage(row);
          setOpenStockTypeDialog(false);
          setOpenPackageSelectDialog(false);
          setOpenProductDialog(true);
        }}
      />

      <ItemTableModal
        open={openItemDialog}
        onClose={() => {
          setOpenItemDialog(false);
          setSelectedItem(null);
        }}
        item={selectedItem}
      />
      <PaymentMethodDialog
        open={openPrintDialog}
        onClose={() => setOpenPrintDialog(false)}
        onSelect={async (method) => {
          await handleSelectPDF(method);
        }}
      />
    </>
  );
};

export default Page;
